module.exports = __webpack_public_path__ + "static/kababayan-b16eefa03e1af04adfddd1fca94d009b.jpg";